import {useMemo} from 'react';

import {
  CMemberStatus,
  IGetGroupDashboardResponse,
} from '@/dataSource/src/api/groups/entities';

export const useSplitBillsGroupActions = (
  groupId?: string,
  groupData?: IGetGroupDashboardResponse,
) => {
  const shouldShowGroupActions = useMemo(() => {
    if (!groupId || !groupData) return false;

    const members = groupData.members ?? [];
    const hasAtLeastTwoParticipants = members.length >= 2;

    return (
      hasAtLeastTwoParticipants &&
      members.every(member => member.status === CMemberStatus.ACTIVE)
    );
  }, [groupData, groupId]);

  return {
    shouldShowGroupActions,
    shouldShowShareLinkCard: !shouldShowGroupActions,
  };
};
